import { Link } from 'react-router-dom';
import { locations } from '../../../mocks/studios';

export default function ServiceAreas() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-amber-600 text-xs font-bold uppercase tracking-widest mb-3 block">
            Find Us Nearby
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-stone-900 mb-5">
            Studio Spaces Near You
          </h2>
          <p className="text-stone-500 text-lg max-w-xl mx-auto">
            Serving creators in major metro areas and local creative hubs across the country.
          </p>
        </div>

        {/* Map + Locations Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
          {/* Map */}
          <div className="lg:col-span-3 rounded-2xl overflow-hidden border border-stone-200 h-[420px]">
            <iframe
              title="Studio locations map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12097.743218967815!2d-73.99099329999998!3d40.71081!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2598f8fa1b895%3A0xae8ce7a47e7a08ae!2sSoHo%2C%20New%20York%2C%20NY!5e0!3m2!1sen!2sus!4v1742000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* Location Cards */}
          <div className="lg:col-span-2 flex flex-col gap-3">
            {locations.map((loc) => (
              <Link
                key={loc.slug}
                to={loc.slug}
                className="group flex items-center justify-between bg-stone-50 hover:bg-amber-50 border border-stone-200 hover:border-amber-200 rounded-xl px-5 py-4 transition-all cursor-pointer"
              >
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-white border border-stone-200 group-hover:border-amber-200 rounded-lg flex-shrink-0">
                    <i className="ri-map-pin-2-fill text-amber-500 text-base" />
                  </div>
                  <div>
                    <p className="font-semibold text-stone-900 text-sm">{loc.city}, {loc.state}</p>
                    <p className="text-stone-500 text-xs mt-0.5">{loc.description}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className="text-xs font-semibold text-amber-600 bg-amber-100 px-2.5 py-1 rounded-full whitespace-nowrap">
                    {loc.studios} Studios
                  </span>
                  <i className="ri-arrow-right-line text-stone-400 group-hover:text-amber-500 transition-colors text-base" />
                </div>
              </Link>
            ))}

            {/* CTA */}
            <div className="mt-2 bg-stone-900 rounded-xl px-5 py-5 text-center">
              <p className="text-stone-400 text-sm mb-3">
                Don&apos;t see your city? We&apos;re expanding fast.
              </p>
              <a
                href="mailto:hello@bookmystudiospace.com"
                className="text-amber-400 hover:text-amber-300 text-sm font-semibold transition-colors cursor-pointer"
              >
                Request a location &rarr;
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
